module.exports = "/_next/static/images/404-0766b39d86bcc69894658a50f06adf65.svg";